import { useContext, useEffect, useMemo } from 'react';
import { PickingInfo } from '@deck.gl/core/typed';
import { MjolnirGestureEvent } from 'mjolnir.js';
import { LocationFormContext } from '../../../context';
import { EditMapCrosswalks } from './EditMapCrosswalks';
import { useSelectedCrosswalk } from '../useSelectedCrosswalk';
import { DEFAULT_ZOOM_LEVEL } from 'components/LocationForm/const';
import { Position } from 'types/geojson';
import { BaseMap } from 'components/maps/BaseMap';

const useCrosswalksMap = () => {
  const { selectedCrosswalk, setSelectedCrosswalk } = useSelectedCrosswalk();

  useEffect(() => {
    return () => setSelectedCrosswalk(undefined);
  }, [setSelectedCrosswalk]);

  const handleMapClick = (info: PickingInfo, event: MjolnirGestureEvent) => {
    if (!selectedCrosswalk || event?.target?.tagName === 'line' || event.rightButton) {
      return null;
    }
    const coordinates = selectedCrosswalk?.geometry?.coordinates ?? [];
    const newCoordinate = info.coordinate as [number, number];

    setSelectedCrosswalk((prev) => ({
      ...prev,
      geometry: { type: 'LineString', coordinates: coordinates.concat([newCoordinate]) },
    }));
  };

  return {
    onMapClick: handleMapClick,
  };
};

export const CrosswalksMap = () => {
  const { values } = useContext(LocationFormContext);
  const { onMapClick } = useCrosswalksMap();

  const viewState = useMemo(() => {
    const coordinates = values?.geometry?.coordinates as Position;

    return coordinates
      ? {
          longitude: coordinates[0],
          latitude: coordinates[1],
          zoom: DEFAULT_ZOOM_LEVEL,
        }
      : undefined;
  }, [values?.geometry?.coordinates]);

  return (
    <BaseMap viewState={viewState} deckProps={{ onClick: onMapClick }}>
      <EditMapCrosswalks location={values} />
    </BaseMap>
  );
};
